export enum UserCompanyType {
  CONCIERGE = 'CONCIERGE',
  LANDLORD = 'LANDLORD',
  HOTEL_CAMPING_RESIDENCE = 'HOTEL_CAMPING_RESIDENCE',
  CLEANING_SERVICE = 'CLEANING_SERVICE',
  LAUNDRY = 'LAUNDRY',
  OTHER = 'OTHER',
}
